export enum LanguageEnum {
  PORTUGUESE = "Português",
  ENGLISH = "Inglês",
  SPANISH = "Espanhol",
}

export type LanguageNameKey = keyof typeof LanguageEnum;

export enum LanguageProficiencyEnum {
  BASIC = "Básico",
  INTERMEDIARY = "Intermediário",
  FLUENT = "Fluente",
}

export type LanguageProficiencyKey = keyof typeof LanguageProficiencyEnum;
